import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { breakpoints, colors, fontWeights } from '@/styles'

const TabsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
  position: relative;
  overflow: hidden;
`

const ContractTab = styled(NavLink)`
  font-weight: ${fontWeights.medium};
  display: flex;
  flex-direction: column;
  align-items: center;

  &.active > div > div {
    box-shadow: 0 0 0 4px #bac8d5;
  }

  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    &.active > div > div {
      box-shadow: 0 0 0 3px #bac8d5;
    }
  }

  ${props =>
    props.disabled &&
    `
    pointer-events: none;

    > div > div {
      background: ${colors.grey};
    }

    p {
      color: ${colors.grey};
    }
  `}
`

const StepWrapper = styled.div`
  z-index: 1;
  background: white;
  padding: 5px 15px;

  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    padding: 5px 12px;
  }
`

const Step = styled.div`
  background: ${colors.secondary};
  color: ${colors.white};
  border-radius: 50%;
  width: 26px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  ${props =>
    props.line
      ? `
    :after {
      content: '';
      position: absolute;
      border-bottom: 1px solid ${props.lineDisabled ? colors.grey : colors.secondary};
      top: 12px;
      left: 40px;
      width: 250px;
      pointer-events: none;
    }
  `
      : `
  :after {
      content: '';
      position: absolute;
      border-bottom: 5px solid ${colors.white};
      top: 10px;
      left: 35px;
      width: 50px;
    }
  `}

  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    width: 20px;
    height: 20px;
    font-size: 13px;

    ${props =>
      props.line
        ? `
    :after {
      content: '';
      position: absolute;
      border-bottom: 1px solid ${props.lineDisabled ? colors.grey : colors.secondary};
      top: 10px;
      left: 30px;
      width: 225px;
    }
  `
        : `
  :after {
      content: '';
      position: absolute;
      border-bottom: 5px solid ${colors.white};
      top: 8px;
      left: 25px;
      width: 50px;
    }
  `}
  }
`

const TabName = styled.p`
  color: ${colors.secondary};
  font-size: 20px;
  line-height: 27px;
  display: flex;
  align-items: center;
  margin: 0;

  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    font-size: 13px;
  }
`

const NavigationTabs = ({ getUrl, validPartiesInfo, validTermsInfo }) => {
  const { t } = useTranslation()
  const disableRentalTerms = !validPartiesInfo
  const disableAddendums = !validTermsInfo

  return (
    <TabsContainer>
      <ContractTab exact to={getUrl()}>
        <StepWrapper>
          <Step line lineDisabled={disableRentalTerms}>
            1
          </Step>
        </StepWrapper>
        <TabName>{t('l.contract.create.parties.tab', 'Parties')} </TabName>
      </ContractTab>
      <ContractTab to={getUrl('terms')} disabled={disableRentalTerms}>
        <StepWrapper>
          <Step line lineDisabled={disableRentalTerms || disableAddendums}>
            2
          </Step>
        </StepWrapper>
        <TabName>{t('l.contract.create.rental_terms.tab', 'Rental Terms')}</TabName>
      </ContractTab>
      <ContractTab to={getUrl('addendums')} disabled={disableRentalTerms || disableAddendums}>
        <StepWrapper>
          <Step>3</Step>
        </StepWrapper>
        <TabName>{t('l.contract.create.addendums.tab', 'Addendums')}</TabName>
      </ContractTab>
    </TabsContainer>
  )
}

export default NavigationTabs
